import { IconWrapper } from '../runtime';
export default IconWrapper('ofd_professional_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#FF7A0D"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 14H16C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14Z",
      "fill": "#E56700"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 14H16C16 15.1046 15.1046 16 14 16H8V14Z",
      "fill": "#FF9A47"
    }
  }), h("path", {
    "attrs": {
      "d": "M5 4.5H6.5V12H5V4.5Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M3 5.5H8V7H3V5.5Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8.5 7.00022H7.50007C6.11925 7.00022 4.99987 5.88084 4.99987 4.50002C4.99987 3.1192 6.11925 1.99982 7.50007 1.99982H8.5V3.49982H7.49987C6.94758 3.49982 6.49987 3.94753 6.49987 4.49982C6.49987 5.0521 6.94758 5.49982 7.49987 5.49982H8.5V7.00022Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M10 7.00041H10.9999C12.3808 7.00041 13.5001 5.88103 13.5001 4.5002C13.5001 3.11938 12.3808 2 10.9999 2H10V3.5H11.0001C11.5524 3.5 12.0001 3.94772 12.0001 4.5C12.0001 5.05228 11.5524 5.5 11.0001 5.5H10V7.00041Z",
      "fill": "white"
    }
  })]);
});